import { useEffect, useRef, useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { PiSubtractSquareDuotone } from 'react-icons/pi';

const SubTaskContent = ({ subTask }) => {
  const {
    key,
    fields: { summary, assignee, status },
  } = subTask;

  const [subtaskStatus, setSubtaskStatus] = useState(status.name);
  const [showStatusOptions, setShowStatusOptions] = useState(false);

  const hanldeStatusChange = (status) => {
    setSubtaskStatus(status);
    setShowStatusOptions(false);
  };
  const statusRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setShowStatusOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    // eslint-disable-next-line
    <div
      className="flex items-center justify-between border  border-zinc-700 px-2 py-1 text-sm transition duration-150 hover:bg-[#1f1f25] hover:text-white"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center gap-3">
        <span className="rounded bg-[#5652CF] p-[2px]">
          <PiSubtractSquareDuotone className="text-white" />
        </span>
        <span className="text-base font-semibold">{key}</span>
        <div ref={statusRef} className="mr-3">
          <button
            className={`flex items-center justify-center gap-1 rounded-3xl px-2 py-0.5 text-[12px] font-semibold uppercase ${
              subtaskStatus === 'To Do' ? 'bg-[#5652CF]' : 'bg-green-500'
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setShowStatusOptions((prev) => !prev);
            }}
          >
            <span className="mt-1">{subtaskStatus}</span>
            <MdKeyboardArrowDown size={15} className="font-semibold" />
          </button>
          {showStatusOptions && (
            <div
              className={`absolute ${
                showStatusOptions ? 'flex' : 'hidden'
              } z-50 flex-col items-center justify-center gap-2 rounded-lg bg-[#1d1d1f] p-2 text-gray-50`}
            >
              {/* eslint-disable-next-line */}
              <span
                onClick={() => hanldeStatusChange('In Progress')}
                className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
              >
                In Progress
              </span>
              {/* eslint-disable-next-line */}
              <span
                onClick={() => hanldeStatusChange('To Do')}
                className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
              >
                To Do
              </span>
            </div>
          )}
        </div>
        <p className="text-base font-semibold">{summary}</p>
      </div>
      <div className="flex items-center gap-8">
        <span className="inline-flex items-center justify-center gap-2 rounded-3xl border border-zinc-600 bg-zinc-950 px-1.5 py-0.5 text-sm">
          <FaUserCircle />
          {assignee?.displayName}
        </span>
      </div>
    </div>
  );
};

export default SubTaskContent;
